import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
// import classNames from "classnames";
// @material-ui/core components
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import { Link } from "react-router-dom";
// @material-ui/icons
import D1Icon from "@material-ui/icons/Palette";
import D2Icon from "@material-ui/icons/People";
import D3Icon from "@material-ui/icons/AssignmentTurnedIn";
import D4Icon from "@material-ui/icons/ImportantDevices";
import D5Icon from "@material-ui/icons/Favorite";
import D6Icon from "@material-ui/icons/Work";
import D7Icon from "@material-ui/icons/Games";
import FlightTakeoffIcon from "@material-ui/icons/FlightTakeoff";
import AlarmIcon from "@material-ui/icons/Alarm";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import Button from "components/CustomButtons/Button.jsx";
import Domain1 from "components/Typography/Domain1.jsx";
import Domain2 from "components/Typography/Domain2.jsx";
import Domain3 from "components/Typography/Domain3.jsx";
import Domain4 from "components/Typography/Domain4.jsx";
import Domain5 from "components/Typography/Domain5.jsx";
import Domain6 from "components/Typography/Domain6.jsx";
import Domain7 from "components/Typography/Domain7.jsx";
import Avatar from "@material-ui/core/Avatar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import withStyles from "@material-ui/core/styles/withStyles";
import pdCourseStyle from "assets/jss/material-kit-pro-react/components/pdCourseStyle.jsx";

function PDCourseCard({ ...props }) {
  const { classes, id, domain, name, sd } = props;
  let iconDomain = null;
  let domainName = null;
  let domainId = id.split("_").shift();

  let iconStyle = {
    color: "black"
  };

  const startDateToDisplay = sd === "TBC" ? "TBC" : new Date(sd).toDateString();

  switch (domainId) {
    case "D1":
      iconStyle.color = pdCourseStyle.d1.color;
      iconDomain = <D1Icon style={iconStyle} />;
      domainName = <Domain1>{domain}</Domain1>;
      break;
    case "D2":
      iconStyle.color = pdCourseStyle.d2.color;
      iconDomain = <D2Icon style={iconStyle} />;
      domainName = <Domain2>{domain}</Domain2>;
      break;
    case "D3":
      iconStyle.color = pdCourseStyle.d3.color;
      iconDomain = <D3Icon style={iconStyle} />;
      domainName = <Domain3>{domain}</Domain3>;
      break;
    case "D4":
      iconStyle.color = pdCourseStyle.d4.color;
      iconDomain = <D4Icon style={iconStyle} />;
      domainName = <Domain4>{domain}</Domain4>;
      break;
    case "D5":
      iconStyle.color = pdCourseStyle.d5.color;
      iconDomain = <D5Icon style={iconStyle} />;
      domainName = <Domain5>{domain}</Domain5>;
      break;
    case "D6":
      iconStyle.color = pdCourseStyle.d6.color;
      iconDomain = <D6Icon style={iconStyle} />;
      domainName = <Domain6>{domain}</Domain6>;
      break;
    case "D7":
      iconStyle.color = pdCourseStyle.d7.color;
      iconDomain = <D7Icon style={iconStyle} />;
      domainName = <Domain7>{domainName}</Domain7>;
      break;
  }

  const images = require.context("../../assets/img/courses", true);
  const image = images(`./${id}.png`);

  return (
    <div className={classes.domainCircleScoreStyle}>
      <Card blog>
        <CardHeader image>
          <img src={image} alt={name} />
          <div
            className={classes.coloredShadow}
            style={{
              backgroundImage: `url(/assets/img/courses/${id}.png)`,
              opacity: "1"
            }}
          />
        </CardHeader>
        <CardBody>
          <h6 className={`${classes.cardCategory} ${classes.cardDescription}`}>
            {iconDomain} {domainName}
          </h6>
          <h4 className={classes.cardTitle}>{name}</h4>
          <div className={classes.cardDetails}>
            <List className={classes.list} dense>
              <ListItem>
                <Avatar>
                  <FlightTakeoffIcon />
                </Avatar>
                <ListItemText primary="Start date" secondary={startDateToDisplay} />
              </ListItem>
              <ListItem>
                <Avatar>
                  <CalendarTodayIcon />
                </Avatar>
                <ListItemText primary="Total time" secondary="3 hours" />
              </ListItem>
              <ListItem>
                <Avatar>
                  <AlarmIcon />
                </Avatar>
                <ListItemText primary="Weeks to complete" secondary="2 weeks" />
              </ListItem>
            </List>
          </div>
        </CardBody>
        <CardFooter>
          <div className={`${classes.stats} ${classes.justifyContentCenter}`}>
            <Link to={`/module/${id}`}>
              <Button color="primary">Find out more</Button>
            </Link>
          </div>
        </CardFooter>
      </Card>
    </div>
  );
}

PDCourseCard.defaultProps = {
  iconColor: "gray"
};

PDCourseCard.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  domain: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  sd: PropTypes.string.isRequired
};

export default withStyles(pdCourseStyle)(PDCourseCard);
